export const messages = {
  en: {
    addPurchaseApply: {
      purchaser: 'Purchaser',
      return: 'Return',
      warehouse: 'Warehouse',
      requiredSelectWarehouse: 'Required, please select warehouse',
      contact: 'Contact',
      requiredContact: 'Required, please enter contact',
      phone: 'Phone',
      requiredPhone: 'Required, please enter phone',
      applyDesc: 'Application Description',
      requiredDesc: 'Required, please enter description',
      purchaseItems: 'Purchase Items',
      select: 'Select',
      itemType: 'Item Type',
      itemNameCode: 'Item Name(Code)',
      itemSpec: 'Item Specification',
      price: 'Price',
      selectPrice: 'Please select price',
      itemStock: 'Item Stock',
      applyQuantity: 'Apply Quantity',
      requiredQuantity: 'Required, please enter quantity',
      remark: 'Remark',
      optionalRemark: 'Optional, please enter remark',
      operation: 'Operation',
      remove: 'Remove',
      approver: 'Approver',
      requiredApprover: 'Required, please select approver',
      submit: 'Submit',
      noItemsSelected: 'No items selected!',
      sameWarehouseRequired: 'Purchased items must come from the same warehouse!',
      selectPriceRequired: 'Please select price!',
      quantityRequired: 'Please enter quantity!',
      selectWarehouseRequired: 'Please select warehouse!',
      contactRequired: 'Please enter contact!',
      phoneRequired: 'Please enter phone!',
      descRequired: 'Please enter description!'
    },
    chooseResourceStore2: {
      title: '[Item Collection/Purchase Application/Direct Outbound] Select Items',
      selectWarehouse: 'Please select warehouse',
      selectItemType: 'Please select item type',
      selectSubType: 'Please select sub type',
      inputItemName: 'Enter item management name',
      warehouse: 'Warehouse',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      fixedItem: 'Fixed Item',
      itemPrice: 'Item Price',
      itemStock: 'Item Stock',
      selectItemsRequired: 'Please select items to purchase'
    },
  },
  zh: {
    addPurchaseApply: {
      purchaser: '采购人',
      return: '返回',
      warehouse: '仓库',
      requiredSelectWarehouse: '必填，请选择仓库',
      contact: '联系人',
      requiredContact: '必填，请填写联系人',
      phone: '联系电话',
      requiredPhone: '必填，请填写联系电话',
      applyDesc: '申请说明',
      requiredDesc: '必填，请填写申请说明',
      purchaseItems: '采购物品',
      select: '选择',
      itemType: '物品类型',
      itemNameCode: '物品名称(编码)',
      itemSpec: '物品规格',
      price: '价格',
      selectPrice: '请选择价格',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      requiredQuantity: '必填，请填写申请数量',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      operation: '操作',
      remove: '移除',
      approver: '审批人',
      requiredApprover: '必填，请选择审批人',
      submit: '提交',
      noItemsSelected: '未选择采购物品！',
      sameWarehouseRequired: '采购商品需来自同一仓库！',
      selectPriceRequired: '请选择价格！',
      quantityRequired: '请填写申请数量！',
      selectWarehouseRequired: '请选择仓库！',
      contactRequired: '请填写联系人！',
      phoneRequired: '请填写联系电话！',
      descRequired: '请填写申请说明！'
    },
    chooseResourceStore2: {
      title: '【物品领用/采购申请/直接出库】选择物品',
      selectWarehouse: '请选择仓库',
      selectItemType: '请选择物品类型',
      selectSubType: '请选择二级分类',
      inputItemName: '输入物品管理名称',
      warehouse: '仓库',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      fixedItem: '固定物品',
      itemPrice: '物品价格',
      itemStock: '物品库存',
      selectItemsRequired: '请选择需要采购的物品'
    },
  }
}